export default {
  mapsApiKey: process.env.REACT_APP_GMAPS_API_KEY || null
}
